module.exports = __webpack_public_path__ + "controller-1c62a01d926d1c82baddc7557e67ed8e.png";